// Packages
import tw, { styled, css } from 'twin.macro'
import HorizontalFlourish from '../../_images/horizontal-flourish.svg'

export const Container = styled.div(() => [
  ``,
  tw`container mx-auto text-white pt-10 md:pt-10 text-[#333333]`,
])

export const Title = styled.h1(() => [
  tw` text-title uppercase pb-2 text-center font-bold text-[#333333] md:text-center md:text-5xl leading-none md:leading-[1.2]`,
])

export const Standfirst = styled.h1(({ className }) => [
  `letter-spacing: -0.41px;`,
  tw`text-title uppercase pb-8 text-center text-[#333333] font-thin leading-none md:leading-snug md:text-center md:pb-8 md:text-[46px]`,
  className?.includes('de') &&
    `@media (max-width: 768px) { font-size: clamp(20px, 8vw, 30px); }`,
])

// Modal mask
export const ModalMask = styled.div(() => [
  `background-color: rgba(0,0,0,0.5);`,
  tw`fixed w-full h-full z-50 top-0 left-0`,
])

const introContent = css`
  p {
    color: #333;
  }
  p + p {
    margin-top: 1em;
  }
  a {
    &:link,
    &:visited,
    &:hover,
    &:focus,
    &:active {
      text-decoration: underline;
    }
  }
`

// export const Paragraph = styled.p(() => [
export const Paragraph = styled.div(() => [
  `text-wrap: pretty;`,
  tw`text-base md:text-introcopy font-light text-[#333333] px-0 lg:px-14 text-center md:text-center md:px-0 mx-auto`,
  introContent,
])

export const PocketText = styled.div(() => [
  `a {
    &:link, &:visited, &:hover, &:focus, &:active {
      text-decoration: underline;
      color: #006FCF;
    }
    &:focus {
      outline: 1px dashed #fff;
      outline-offset: 3px;
    }
  }`,
  tw`text-copy text-pretty text-black px-4 lg:px-14 text-center md:text-center md:px-0 mt-8 mx-auto`,
])

export const TopBanner = styled.div(() => [
  css`
    background:
      url('${HorizontalFlourish}'),
      linear-gradient(to right, rgba(199, 200, 202, 1), rgba(240, 241, 242, 1));
    background-size: cover;
    background-position: right;
  `,
  tw`text-black text-center px-4 lg:px-14 py-4 mx-auto mt-8`,
])

export const TcLink = styled.div(() => [
  `a {
    &:link, &:visited, &:hover, &:focus, &:active {
      text-decoration: underline;
    }
    &:focus {
      outline: 1px dashed #fff;
      outline-offset: 3px;
    }
  }`,
  tw`text-base md:text-introcopy text-[#006FCF] px-4 text-center md:text-center md:px-0 mt-8 mx-auto cursor-pointer`,
])

export const TcLinkExt = styled.a(() => [
  `a {
    &:link, &:visited, &:hover, &:focus, &:active {
      text-decoration: underline;
    }
    &:focus {
      outline: 1px dashed #fff;
      outline-offset: 3px;
    }
  }`,
  tw`block text-base md:text-introcopy text-[#006FCF] px-4 text-center md:text-center md:px-0 mt-8 mx-auto cursor-pointer`,
])

export const CreditCardsWrapper = styled.div(() => [
  tw`flex flex-col md:flex-row justify-center items-stretch gap-6 w-full mt-4`,
])

export const CreditCard = styled.div(({ single }) => [
  tw`flex-1 bg-white rounded-lg border border-gray-200 flex flex-col overflow-hidden text-[#333333]`,
  single && tw`flex-none w-full md:w-1/2`,
])

export const CardHeader = styled.div(() => [
  tw`p-2 bg-gray-200 flex justify-center items-center`,
])

export const CardBody = styled.div(() => [
  tw`p-6 flex flex-row justify-center items-center gap-6`,
])

export const CreditItem = styled.div(() => [
  tw`flex-1 flex flex-col items-center gap-1`,
])

export const CreditAmount = styled.div(() => [
  tw`text-center text-copy font-normal`,
])

export const CreditPeriod = styled.div(() => [
  tw`text-center text-copy font-light`,
])

export const CreditDivider = styled.div(() => [tw`w-px h-8 bg-gray-300`])

export const HotelRestaurantInfo = styled.div(() => [
  tw`text-copy px-0 md:px-6 text-center text-[#333333] mt-8 mx-auto flex row-auto justify-center`,
  introContent,
])

export const HotelRestaurantInfo1 = styled.div(() => [
  tw`text-copy font-bold px-0 md:px-6 text-center text-[#333333] mt-8 mx-auto flex row-auto justify-center`,
  introContent,
])
